import { jwtDecode } from 'jwt-decode';

export function isTokenExpired(token) {
    try {
        const decoded = jwtDecode(token);
        const now = Date.now() / 1000;
        return decoded.exp < now;
    } catch (err) {
        return true;
    }
}

export function getSession() {
    try {
        const raw = localStorage.getItem("odoo_session");
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}